import { selectors } from '@hixme/auth-ui'

/**
 * @param {object} opts
 * @param {string[] | undefined} opts.allowedRoles
 * @param {string[] | undefined} opts.allowedUsers - if non-empty, user id must be included
 * @param {function} opts.callback
 *
 * When both `allowedRoles` and `allowedUsers` are non-empty, **both** must pass (AND).
 * User-id-only (e.g. Tools → Finance) or role-only (e.g. HRIS) still work as before.
 */
export default ({ allowedRoles, allowedUsers, callback }) =>
  (dispatch, getState) => {
    const error = {
      status: 401,
      message: 'not authorized',
    }

    const user = selectors.getUserId(getState())
    const userRole = selectors.getRole(getState())

    const hasUserList = Array.isArray(allowedUsers) && allowedUsers.length > 0
    const hasRoleList = Array.isArray(allowedRoles) && allowedRoles.length > 0

    if (hasUserList) {
      if (!user || !allowedUsers.includes(user)) {
        callback(error)
        return
      }
    }

    if (hasRoleList) {
      if (!userRole || !allowedRoles.includes(userRole)) {
        callback(error)
        return
      }
    }

    if (!hasUserList && !hasRoleList) {
      callback(error)
      return
    }

    callback()
  }
